"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const { hexToColor, colorToHex } = require('./color');
const headers = ({ urls }) => ({
    "item ID (Read-Only)": {
        isReadOnly: false,
        get: item => item.id,
        set: (item, val) => {
            if (val)
                item.id = val;
        },
    },
    "original ID": {
        isReadOnly: false,
        get: item => item.import_data?.original_id,
        set: (item, val) => {
            if (!val)
                return;
            item.import_data = {
                source: "csv import",
                original_id: val,
            };
        }
    },
    "type": {
        isReadOnly: false,
        get: item => item.item_type,
        set: (item, val) => item.item_type = val,
    },
    "custom_type": {
        isReadOnly: false,
        get: item => item.custom_type,
        set: (item, val) => item.custom_type = val,
    },
    "created (Read-Only)": {
        isReadOnly: true,
        get: item => item.user_data.created,
    },
    "updated (Read-Only)": {
        isReadOnly: true,
        get: item => item.user_data.modified,
    },
    "read": {
        isReadOnly: false,
        get: item => !item.user_data.unread,
        set: (item, val) => {
            val = val || "";
            if (val === "")
                return;
            const read = val.toLowerCase() === "true";
            if (!item.user_data)
                item.user_data = {};
            item.user_data.unread = !read;
        }
    },
    "notes": {
        isReadOnly: false,
        get: item => item.user_data.notes,
        set: (item, val) => {
            if (!item.user_data)
                item.user_data = {};
            item.user_data.notes = val || "";
        }
    },
    "color": {
        isReadOnly: false,
        get: item => item.user_data.color
            && hexToColor(item.user_data.color),
        set: (item, val) => {
            val = val || "";
            item.user_data = item.user_data || {};
            item.user_data.color = val && colorToHex(val);
        },
    },
    "flag": {
        isReadOnly: false,
        get: item => !!item.user_data.star,
        set: (item, val) => {
            val = val || "false";
            const starValue = val.toLowerCase() === "true";
            item.user_data = item.user_data || {};
            item.user_data.star = starValue;
        },
    },
    "ratings": {
        isReadOnly: false,
        get: item => item.user_data.rating,
        set: (item, val) => {
            val = val || "";
            if (val === "")
                return;
            item.user_data = item.user_data || {};
            item.user_data.rating = Number(val);
        },
    },
    "doi": {
        isReadOnly: false,
        get: item => item.ext_ids.doi,
        set: (item, val) => {
            val = val || "";
            item.ext_ids = item.ext_ids || {};
            item.ext_ids.doi = val;
        },
    },
    "patent_id": {
        isReadOnly: false,
        get: item => item.ext_ids.patent_id,
        set: (item, val) => {
            val = val || "";
            item.ext_ids = item.ext_ids || {};
            item.ext_ids.patent_id = val;
        },
    },
    "pmid": {
        isReadOnly: false,
        get: item => item.ext_ids.pmid,
        set: (item, val) => {
            val = val || "";
            item.ext_ids = item.ext_ids || {};
            item.ext_ids.pmid = val;
        },
    },
    "pmcid": {
        isReadOnly: false,
        get: item => item.ext_ids.pmcid,
        set: (item, val) => {
            val = val || "";
            item.ext_ids = item.ext_ids || {};
            item.ext_ids.pmcid = val;
        },
    },
    "arxiv": {
        isReadOnly: false,
        get: item => item.ext_ids.arxiv,
        set: (item, val) => {
            val = val || "";
            item.ext_ids = item.ext_ids || {};
            item.ext_ids.arxiv = val;
        }
    },
    "file (Read-Only)": {
        isReadOnly: true,
        get: item => item.files
            && Array.isArray(item.files)
            && item.files.find((f) => f.type === "article")
            && (item.files.find((f) => f.type === "article").name || "file available"),
    },
    "year": {
        isReadOnly: false,
        get: item => item.article.year,
        set: (item, val) => {
            val = val || "";
            item.article = item.article || {};
            item.article.year = val && Number(val);
        },
    },
    "Library URL": {
        isReadOnly: true,
        get: item => urls.baseAppUrl + `/library/${item.collection_id}/item/${item.id}`,
    },
    "PDF URL": {
        isReadOnly: true,
        get: item => {
            if (item.files?.length)
                return urls.baseWebUrl + `/library/${item.collection_id}:${item.id}`;
        },
    },
    "Copyright status": {
        isReadOnly: false,
        get: item => {
            if (item?.user_data?.copyright_status === "covered")
                return "Green";
            if (item?.user_data?.copyright_status === "not_covered")
                return "Red";
            return "None";
        },
        set: (item, val) => {
            item.user_data = item.user_data || {};
            if (!val || val.toLowerCase() === "none") {
                item.user_data.copyright_status = null;
                return;
            }
            if (val.toLowerCase() === "green") {
                item.user_data.copyright_status = "covered";
                return;
            }
            if (val.toLowerCase() === "red") {
                item.user_data.copyright_status = "not_covered";
                return;
            }
        }
    }
});
exports.default = headers;
